import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { API_BASE_RELATIVE_PATH, API_BASE_PATH } from "../Config/Config";

let productId;

const fetchRepos = async () => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  const user = JSON.parse(userDetails);

  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=getRepos&companyid=${user.companyid}&productid=${productId}`,
  );

  return response.data;
};

const useRepoQuery = () => {
  const query = useQuery({
    queryKey: ["repos"],
    queryFn: () => {
      return fetchRepos(productId);
    },
    enabled: false,
    retry: true,
    cacheTime: 90000,
    refetchInterval: false,
    refetchIntervalInBackground: false,
    staleTime: Infinity,
  });

  const refetchWithParams = (id) => {
    productId = id;
    query.refetch();
  };

  return {
    ...query,
    refetchWithParams,
  };
};

export default useRepoQuery;
